import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/icon/phone-icon.svg")